/* eslint-disable no-undef */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button, 
  Card, 
  Container, 
  Modal, 
  Loader,
} from '../../ui';
import { payment } from '../../../operations';
import { 
  clean, 
  setPaymentValue,
  setStepInnerPage
} from '../../../actions';

class PaymentCredit extends Component {

  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.submitPayment = this.submitPayment.bind(this);
  }

  submitPayment = (tokenId) => {
    const { quoterPurchase, quoterData, currency } = this.props;
    quoterPurchase(tokenId, quoterData, currency);
  }

  openModal = () => {
    const {
      email,
      currency,
      installments,
      checkoutCard,
      closeSiemprePagoModal
    } = this.props;

    PWCheckout.Bind('tokenCreated', (tokenInfo) => {
      const { TokenId } = tokenInfo;
      this.submitPayment(TokenId);
    });

    PWCheckout.Bind('closed', (closeInfo) => {
      const { Reason } = closeInfo;
      if(Reason !== 'TOKEN_RECEIVED') closeSiemprePagoModal();
    });

    PWCheckout.SetProperties({
      name: `${currency} ${installments.amount} en ${installments.value} cuotas`,
      image: 'https://cliente.segurossura.com.uy/Images/Pagos/SURA_logo.png',
      email: email,
      email_edit: "false",
      amount: installments.amount,
      lang: 'ESP',
      form_id: 'payment_form',
      checkout_card: checkoutCard,
      autoSubmit: "false",
      close_onclick: "false"
    });

    document.getElementById("btnPayHidden").click();
  }

  render() {
    this.openModal();
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    email: state.client ? state.client.email : '',
    installments: state.payment.installments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    quoterPurchase: (tokenId, quoterData, currency) => {
      dispatch(payment.quoterPurchase(tokenId, quoterData, currency));
    },
    closeSiemprePagoModal: () => {
      dispatch(setPaymentValue('openSiemprePago', false));
    }
  };
};

PaymentCredit.propTypes = {
  currency: PropTypes.string.isRequired,
  checkoutCard: PropTypes.string.isRequired,
  // TODO: change object for shape
  // eslint-disable-next-line react/forbid-prop-types
  quoterData: PropTypes.object.isRequired,
}

PaymentCredit.defaultProps = {
  currency: 'UYU',
  checkoutCard: '2',
  quoterData: {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentCredit);
